// The Hermès tab of a followed public figure's page (16 October 2026).
// Never a guessed gender: the name, or "this public figure".
export default {
  nouvelle: 'New conversation',
  conversations: 'Your conversations',
  lecture: 'Loading…',
  aucune: 'Your conversations with Hermès about this public figure will appear here.',
  seRelit: 'Hermès is reloading the conversation…',
  titre: 'Hermès, on {qui}',
  texte: 'Hermès, Orion’s political assistant, knows the file: what is said every day, the traced quotes, the positions, who talks about them. Ask it to write, to respond or to analyse.',
  departs: {
    tweet: 'Write three click-worthy tweets announcing a statement by {qui}.',
    riposte: 'Draft a response to the most repeated attack this week.',
    faiblesses: 'What are their three weak points in public opinion right now, and how can they be turned around?',
    tiktok: 'Write a thirty-second TikTok script to reach the under-thirties.',
  },
}
